

/*
// =========================
// RigeneraDermo - Gift Wrap (robusto)
// =========================

const RD_GIFT_KEY = 'rd_giftwrap_enabled';            // 0/1
const RD_GIFT_VARIANT_KEY = 'rd_giftwrap_variant_id'; // string
const RD_COOKIE_DAYS = 14;
let rdCheckoutLock = false;
let rdEnforceLock = false;

// ---------- Cookie helpers (condivisione fra sottodomini) ----------
function rdSetCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);

  // Cookie valido su tutti i sottodomini di rigeneradermo.it
  // (se un giorno usi un altro dominio, va aggiornato)
  const domain = '.rigeneradermo.it';

  document.cookie =
    `${encodeURIComponent(name)}=${encodeURIComponent(value)};` +
    `expires=${d.toUTCString()};path=/;domain=${domain};SameSite=Lax;Secure`;
}

function rdGetCookie(name) {
  const key = encodeURIComponent(name) + '=';
  const parts = document.cookie.split(';');
  for (const p of parts) {
    const s = p.trim();
    if (s.startsWith(key)) return decodeURIComponent(s.substring(key.length));
  }
  return null;
}

function rdSaveGiftChoice(enabled) {
  const v = enabled ? '1' : '0';
  localStorage.setItem(RD_GIFT_KEY, v);
  rdSetCookie(RD_GIFT_KEY, v, RD_COOKIE_DAYS);
}

function rdLoadGiftChoice() {
  const ls = localStorage.getItem(RD_GIFT_KEY);
  if (ls === '1' || ls === '0') return ls === '1';

  const ck = rdGetCookie(RD_GIFT_KEY);
  if (ck === '1' || ck === '0') {
    localStorage.setItem(RD_GIFT_KEY, ck);
    return ck === '1';
  }
  return false;
}

function rdSaveVariantId(variantId) {
  if (!variantId) return;
  localStorage.setItem(RD_GIFT_VARIANT_KEY, String(variantId));
  rdSetCookie(RD_GIFT_VARIANT_KEY, String(variantId), RD_COOKIE_DAYS);
}

function rdLoadVariantId() {
  const ls = localStorage.getItem(RD_GIFT_VARIANT_KEY);
  if (ls) return ls;

  const ck = rdGetCookie(RD_GIFT_VARIANT_KEY);
  if (ck) {
    localStorage.setItem(RD_GIFT_VARIANT_KEY, ck);
    return ck;
  }
  return null;
}

// ---------- DOM helpers ----------
function rdFindAnyGiftCheckbox(root = document) {
  return root.querySelector('[data-rd-giftwrap-toggle]');
}

function rdSyncCheckboxesFromStorage() {
  const enabled = rdLoadGiftChoice();
  document.querySelectorAll('[data-rd-giftwrap-toggle]').forEach(cb => {
    cb.checked = enabled;
    const v = cb.getAttribute('data-rd-giftwrap-variant-id');
    if (v) rdSaveVariantId(v);
  });
}

// ---------- Cart API ----------
async function rdGetCart() {
  const r = await fetch('/cart.js', { credentials: 'same-origin' });
  return r.json();
}

async function rdAddVariant(variantId, qty) {
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ id: Number(variantId), quantity: qty })
  });
}

async function rdRemoveLineByKey(lineKey) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ id: lineKey, quantity: 0 })
  });
}

async function rdEnsureGiftWrapState(variantId, enabled) {
  variantId = Number(variantId);
  if (!variantId) return;

  const cart = await rdGetCart();
  const existing = cart.items.find(it => it.variant_id === variantId);

  if (enabled && !existing) {
    await rdAddVariant(variantId, 1);
    return;
  }

  if (!enabled && existing) {
    await rdRemoveLineByKey(existing.key);
  }
}

// ---------- Enforcement: se OFF, il regalo non deve restare nel carrello ----------
async function rdEnforceGiftWrapInvariant() {
  if (rdEnforceLock) return;
  rdEnforceLock = true;

  try {
    const enabled = rdLoadGiftChoice();
    const variantId = rdLoadVariantId() || (rdFindAnyGiftCheckbox()?.getAttribute('data-rd-giftwrap-variant-id'));

    if (!variantId) return;

    // Se OFF: rimuovi sempre (così non "ricompare" dopo altri add-to-cart)
    if (!enabled) {
      await rdEnsureGiftWrapState(variantId, false);
    }
  } catch (e) {
    // ignora: riproverà al prossimo evento
  } finally {
    rdEnforceLock = false;
  }
}

// ---------- Checkbox change: salva e, se OFF, rimuove subito ----------
document.addEventListener('change', async (e) => {
  const cb = e.target && e.target.matches && e.target.matches('[data-rd-giftwrap-toggle]') ? e.target : null;
  if (!cb) return;

  const enabled = cb.checked;
  const variantId = cb.getAttribute('data-rd-giftwrap-variant-id');

  rdSaveGiftChoice(enabled);
  rdSaveVariantId(variantId);

  // Se l’utente toglie la spunta, rimuovi subito dal carrello (senza reload)
  if (!enabled && variantId) {
    try {
      await rdEnsureGiftWrapState(variantId, false);
    } catch (err) {
      // se fallisce, l'enforcement successivo lo rimuoverà comunque
    }
  }
}, true);

// ---------- Checkout interception (submit + click) ----------
async function rdGoCheckoutWithSync(preventEvent, submitterEl) {
  if (rdCheckoutLock) return;
  rdCheckoutLock = true;

  if (preventEvent) {
    preventEvent.preventDefault();
    preventEvent.stopPropagation();
  }

  const enabled = rdLoadGiftChoice();
  const cb = rdFindAnyGiftCheckbox(document);
  const variantId = (cb && cb.getAttribute('data-rd-giftwrap-variant-id')) || rdLoadVariantId();

  try {
    if (variantId) {
      rdSaveVariantId(variantId);
      // Sincronizza ON/OFF solo quando premi Checkout
      await rdEnsureGiftWrapState(variantId, enabled);
    }
  } catch (err) {
    // non blocchiamo il checkout
  }

  window.location.href = '/checkout';
}

// 1) submit del form (copre click + Enter)
document.addEventListener('submit', (e) => {
  const submitter = e.submitter;
  const isCheckout =
    submitter && (submitter.getAttribute('name') === 'checkout' || submitter.id === 'checkout');
  if (!isCheckout) return;

  rdGoCheckoutWithSync(e, submitter);
}, true);

// 2) click su link /checkout
document.addEventListener('click', (e) => {
  const a = e.target.closest && e.target.closest('a[href="/checkout"]');
  if (!a) return;
  rdGoCheckoutWithSync(e, a);
}, true);

// ---------- Hook fetch: dopo ogni update carrello, enforce OFF ----------
(function patchFetch() {
  const _fetch = window.fetch;
  window.fetch = async function(input, init) {
    const res = await _fetch(input, init);

    try {
      const url = (typeof input === 'string') ? input : (input && input.url) || '';
      // Qualsiasi operazione tipica sul carrello
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
        // enforcement asincrono
        rdEnforceGiftWrapInvariant();
      }
    } catch (_) {}

    return res;
  };
})();

// Init
document.addEventListener('DOMContentLoaded', () => {
  rdSyncCheckboxesFromStorage();
  rdEnforceGiftWrapInvariant();
});

document.addEventListener('shopify:section:load', () => {
  rdSyncCheckboxesFromStorage();
  rdEnforceGiftWrapInvariant();
});
*/

// =========================
// Gift wrap - persistente (Horizon-safe)
// - checkbox salva preferenza
// - la preferenza viene riapplicata ad ogni re-render del drawer
// - sync carrello solo quando premi Checkout
// =========================

const RD_GIFT_KEY = 'rd_giftwrap_enabled';
const RD_GIFT_VARIANT_KEY = 'rd_giftwrap_variant_id';
let rdCheckoutLock = false;

// ---- storage helpers (con fallback) ----
function rdStorageSet(key, value) {
  try { localStorage.setItem(key, value); } catch (_) {}
}
function rdStorageGet(key) {
  try { return localStorage.getItem(key); } catch (_) { return null; }
}

function rdSaveChoice(enabled) {
  rdStorageSet(RD_GIFT_KEY, enabled ? '1' : '0');
}
function rdLoadChoice() {
  return rdStorageGet(RD_GIFT_KEY) === '1';
}

function rdSaveVariantId(variantId) {
  if (variantId) rdStorageSet(RD_GIFT_VARIANT_KEY, String(variantId));
}
function rdLoadVariantId() {
  return rdStorageGet(RD_GIFT_VARIANT_KEY);
}

// ---- cart api ----
async function rdGetCart() {
  const r = await fetch('/cart.js', { credentials: 'same-origin' });
  return r.json();
}

async function rdEnsureGiftWrapState(variantId, enabled) {
  variantId = Number(variantId);
  if (!variantId) return;

  const cart = await rdGetCart();
  const existing = cart.items.find(it => it.variant_id === variantId);

  if (enabled && !existing) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    return;
  }

  if (!enabled && existing) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: existing.key, quantity: 0 })
    });
  }
}

// ---- checkbox binding + resync (Horizon re-render) ----
function rdBindGiftCheckbox(cb) {
  if (!cb || cb.dataset.rdBound === '1') return;

  // Applica stato salvato
  cb.checked = rdLoadChoice();

  // Salva scelta (senza toccare il carrello)
  const onChange = () => {
    rdSaveChoice(cb.checked);
    const v = cb.getAttribute('data-rd-giftwrap-variant-id');
    rdSaveVariantId(v);
  };

  cb.addEventListener('change', onChange);
  cb.addEventListener('input', onChange);

  // salva anche subito il variant id
  const v = cb.getAttribute('data-rd-giftwrap-variant-id');
  rdSaveVariantId(v);

  cb.dataset.rdBound = '1';
}

function rdSyncGiftWrapUI() {
  document.querySelectorAll('[data-rd-giftwrap-toggle]').forEach(rdBindGiftCheckbox);
}

// ---- checkout interception (sync solo qui) ----
async function rdGoCheckoutWithSync(evt) {
  if (rdCheckoutLock) return;
  rdCheckoutLock = true;

  evt.preventDefault();
  evt.stopPropagation();

  const enabled = rdLoadChoice();

  const cb = document.querySelector('[data-rd-giftwrap-toggle]');
  const variantId =
    (cb && cb.getAttribute('data-rd-giftwrap-variant-id')) || rdLoadVariantId();

  try {
    if (variantId) await rdEnsureGiftWrapState(variantId, enabled);
  } catch (_) {
    // non blocchiamo
  }

  window.location.href = '/checkout';
}

// submit del form checkout (click + Enter)
document.addEventListener('submit', (e) => {
  const s = e.submitter;
  const isCheckout = s && (s.getAttribute('name') === 'checkout' || s.id === 'checkout');
  if (!isCheckout) return;
  rdGoCheckoutWithSync(e);
}, true);

// click su link /checkout (se presente)
document.addEventListener('click', (e) => {
  const a = e.target.closest?.('a[href="/checkout"]');
  if (!a) return;
  rdGoCheckoutWithSync(e);
}, true);

// ---- MutationObserver: Horizon ricrea il drawer -> risincronizza ----
let rdSyncScheduled = false;
function rdScheduleSync() {
  if (rdSyncScheduled) return;
  rdSyncScheduled = true;
  requestAnimationFrame(() => {
    rdSyncScheduled = false;
    rdSyncGiftWrapUI();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  rdSyncGiftWrapUI();

  const obs = new MutationObserver(() => rdScheduleSync());
  obs.observe(document.documentElement, { childList: true, subtree: true });
});

// Se Shopify ricarica sezioni
document.addEventListener('shopify:section:load', rdSyncGiftWrapUI);
